import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconMessenger$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMessenger extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'aa10e86ec2bf66b0099c1f1f08c4bce770bd7f5f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '511fa1a63fbd4fdfaf2e9b602e130ed06474ce93', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'e02bb4258d1fc890ec44b5af0e1906148d28f949', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.8 10.722c0 4.707-3.94 8.522-8.8 8.522-.897 0-1.762-.13-2.577-.371l-1.914.847a.927.927 0 0 1-1.299-.855V17.14c-1.845-1.562-3.01-3.858-3.01-6.418C2.2 6.015 6.14 2.2 11 2.2s8.8 3.815 8.8 8.522M6.34 12.4l2.553-3.49a.85.85 0 0 1 1.176-.176L12 10.144a.64.64 0 0 0 .76-.008l2.303-1.754c.375-.285.871.168.594.543l-2.677 3.613a.85.85 0 0 1-1.173.173L9.87 11.297a.64.64 0 0 0-.757.005l-2.18 1.64c-.374.282-.866-.167-.592-.542", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-messenger", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-messenger"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-messenger":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMessenger$1);
            }
            break;
    } });
}

const CosmosIconMessenger = CosmosIconMessenger$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMessenger, defineCustomElement };
